import React from 'react'
import { IPolicy } from '@verzekeringapp-mono/shared/src/models/policy'
import { Link } from 'react-router-dom'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getIsPolicyPullable } from '@verzekeringapp-mono/shared/src/state/selectors/policies'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IProps {
  policy: IPolicy
  withDivider?: boolean
}

const GreenCard: React.FC<IProps> = ({ policy, withDivider }) => {
  const isPullable = useAppSelector(getIsPolicyPullable(policy?.id))

  if (!policy?.greenCard && policy?.greenCards.length === 0 && !isPullable)
    return null

  return (
    <div>
      {withDivider && <div className='my-8 border-b border-border-default' />}

      <p className='subtitle mb-4'>Verzekeringsbewijs</p>

      {isPullable && !policy.greenCard && !policy.greenCards && (
        <Link
          to={`/verzekeringsbewijzen/genereren/${policy.id}`}
          className='text-primary primary-btn w-full max-w-[500px]'
        >
          Verzekeringsbewijs genereren
        </Link>
      )}

      {policy.greenCard &&
        (
          <>
            <a
              className='hidden text-sm text-text-brand md:block'
              href={policy.greenCard}
              target='_blank'
              rel='noreferrer'
            >
              <FontAwesomeIcon
                icon={['fal', 'arrow-down']}
                size='sm'
                className='mr-2'
              />
            Open het verzekeringsbewijs
            </a>

            <div className='md:hidden'>
              <button className='primary-btn w-full items-center justify-center max-w-[500px]'>
                <a
                  href={policy.greenCard}
                  target='_blank'
                  rel='noreferrer'
                >
                Open het verzekeringsbewijs
                </a>
              </button>
            </div>
          </>
        )}
    </div>
  )
}

export default GreenCard
